module.exports = __webpack_public_path__ + "img/logo_white.2a3fddac.svg";